import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./features/counter/counterSlice";
import authReducer from "./authentication/authSlice";
import sidebarReducer from "./sidebar/sidebarSlice";
import chartReducer from "./chartContent/chartSlice";
export default configureStore({
  reducer: {
    counter: counterReducer,
    auth: authReducer,
    sidebar: sidebarReducer,
    chartContent: chartReducer,
  },
});
